import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Weblink: Uppdatera användare", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, [
  /*#__PURE__*/_createTextVNode(" Starta en ny synkronisering av användarna från Weblink. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Den hämtar först in en lista på användare som finns i Weblink, och uppdaterar sedan samtalsdatabasen (CallDetailRecords) med användare, så att systemet sedan kan ta ut samtalsstatistik på rätt användare. ")
], -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "ms-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_messages = _resolveComponent("messages")!
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_messages, { ref: "errorHandler" }, null, 512)
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.syncWeblinkUsers && _ctx.syncWeblinkUsers(...args))),
        disabled: _ctx.updatingWeblinkUsers
      }, [
        (!_ctx.updatingWeblinkUsers)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Kör"))
          : _createCommentVNode("", true),
        _createVNode(_component_fa_icon, {
          hidden: !_ctx.updatingWeblinkUsers,
          icon: "spinner",
          spin: _ctx.updatingWeblinkUsers,
          size: "3x"
        }, null, 8, ["hidden", "spin"])
      ], 8, _hoisted_6),
      (_ctx.updateWeblinkUsersStatus)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.updateWeblinkUsersStatus), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}